import React, { useState, useEffect } from 'react';
import PersonAdd from '@mui/icons-material/PersonAdd';

import Attendance from '../../../pages/activities/Attendance'
import ActivityButton from './ActivityButton';

import Congratulations from '../Congratulations';
import { useCode } from '../../../contexts/Code';

import { useCheckActivityCompleted } from '../../../hooks/activity'

const ActivityAttendence = ({ session, activity }) => {
    const {code} = useCode()

    const isCompleted = useCheckActivityCompleted(activity);

    const [openAttendance, setOpenAttendance] = useState(false);
    const [attendance, setAttendance] = useState(false);
    const [congratulations, setCongratulations] = useState(false);

    useEffect(()=> {
        setAttendance(isCompleted);
    }, [isCompleted])

    const congratulationsMessage = code == 45 ? `Congratulations, you have accumulated ${activity ? activity.score : 100} points!` : `¡Felicidades, has acumulado ${activity ? activity.score : 100} puntos!`

    return (
        <>
            <Attendance 
                session={session} 
                activity={activity} 
                openAttendance={openAttendance} 
                setOpenAttendance={setOpenAttendance}
                setAttendance={setAttendance} 
                setCongratulations={setCongratulations} />

            <Congratulations fire={congratulations} message={congratulationsMessage} />
            <ActivityButton
                title={code == 45 ? 'Check attendance' : 'Marcar asistencia'}
                subtitle={`+${activity ? activity.score : 100} puntos`}
                icon={<PersonAdd />}
                iconColor="error"
                clickWrapper={(e) => {
                    setOpenAttendance(true);
                }}
                check={attendance}
                image={"https://i.imgur.com/hMlp9Jr.png"}
            />
        </>
    );
};

export default ActivityAttendence;
